<template>
  <div class="modal-background-layer">
    <div class="modal-container">
      <div :id="id" class="modal modal-shortcut">
        <div class="modal-header modal-top">
          <div class="modal-title">{{ modalTitle }}</div>
        </div>

        <div class="modal-body modal-middle">
          <select
            class="modal-search-dropdowm-list mt-10px"
            name=""
            id=""
            v-model="searchType"
          >
            <option
              v-for="group in itemGroups"
              :key="group.value"
              :value="group.value"
            >
              {{ getGroupText(group) }}
            </option>
          </select>
          <div class="modal-content mb-5px">
            <div
              v-for="item in items"
              :key="item.type || item.name"
              class="modal-item"
              :class="{ selected: isSelected(item) }"
              @click="toggleItem(item)"
            >
              <input
                :id="item.type"
                type="checkbox"
                :checked="isSelected(item)"
                @click.stop="toggleItem(item)"
              />
              <label>{{ item.text }}</label>
            </div>
            <div></div>
          </div>
        </div>
        <div class="modal-buttons modal-bottom">
          <button class="modal-button cancel" @click="closeModal">
            {{ $t("modalButton.cancel") }}
          </button>
          <button class="modal-button done" @click="saveModal">
            {{ $t("modalButton.done") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchType: 0,
      shortCuts: [],
    };
  },
  props: {
    id: {
      type: String,
      default: "selectModal",
    },
    title: {
      type: String,
      default: "",
    },
    trigger: {
      type: Boolean,
      default: false,
    },
    hasSearch: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemGroups: {
      type: Array,
      default: () => [],
    },
    selectedShortCuts: {
      type: Array,
      default: () => [],
    },
    maxShortCuts: {
      type: Number,
      default: 9,
    },
  },
  computed: {
    modalTitle() {
      return this.title || this.$t("modalTitle.addShortCut");
    },
    modalItems() {
      return this.items.filter((item) => item.type);
    },
  },
  watch: {
    trigger(value) {
      if (value) {
        this.syncShortCuts();
        document
          .getElementById(this.id)
          .closest(".modal-background-layer")
          .classList.add("show");
      } else {
        document
          .getElementById(this.id)
          .closest(".modal-background-layer")
          .classList.remove("show");
      }
    },
    searchType(value) {
      this.$emit("changeGroup", value);
    },
    itemGroups: {
      immediate: true,
      handler(groups) {
        if (!groups.length) return;

        const hasSearchType = groups.some(
          (group) => group.value == this.searchType
        );
        if (!hasSearchType) {
          this.searchType = groups[0].value;
        }
      },
    },
    selectedShortCuts() {
      if (this.trigger) {
        this.syncShortCuts();
      }
    },
  },
  methods: {
    syncShortCuts() {
      this.shortCuts = [...this.selectedShortCuts];
    },
    isSelected(item) {
      return this.shortCuts.some((shortCut) => shortCut.type == item.type);
    },
    getGroupSelectedCount(group) {
      const selectedTypes = new Set(this.shortCuts.map((item) => item.type));
      return (
        group.categories?.filter((item) => selectedTypes.has(item.type))
          .length || 0
      );
    },
    getGroupText(group) {
      let text = group.text;
      if (this.getGroupSelectedCount(group) > 0)
        text += ` (${this.getGroupSelectedCount(group)})`;
      return text;
    },
    toggleItem(item) {
      let index = this.shortCuts.findIndex((sc) => sc.type == item.type);
      if (index > -1) {
        this.shortCuts.splice(index, 1);
      } else {
        if (this.shortCuts.length >= this.maxShortCuts) {
          this.$func.message({
            type: "alert",
            mainMessage: "最多可設定9個捷徑",
          });
          return;
        }
        this.shortCuts.push(item);
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
    saveModal() {
      this.$emit("saveModal", this.shortCuts);
    },
  },
};
</script>
